import { render, staticRenderFns } from "./tmAnchors.vue?vue&type=template&id=3bd709dc&"
import script from "./tmAnchors.vue?vue&type=script&lang=js&"
export * from "./tmAnchors.vue?vue&type=script&lang=js&"
import style0 from "./tmAnchors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports